import {
  CONTENTFUL_INPUT_TYPES,
  FORM_CONTEXT_TYPES,
} from '../../shared/constants';

import { ITranslationItem } from '../language';

export const validateForm = (
  validity: ValidityState | null,
  label: string,
  customMessage?: ITranslationItem,
  min?: number,
  max?: number,
  type?: string,
  customValidState?: {
    customPatternMismatch: boolean;
  },
  customContext?: string,
  errorText?: ITranslationItem
): ITranslationItem | undefined => {
  if (!validity) return undefined;
  const { tooShort, valid, valueMissing, tooLong, patternMismatch } = validity;
  const labelForError = label?.toLowerCase();
  if (valid && !customValidState?.customPatternMismatch) {
    return undefined;
  }
  if (!valid && customMessage) {
    return customMessage;
  }
  if (
    type === CONTENTFUL_INPUT_TYPES.textarea &&
    customValidState?.customPatternMismatch
  ) {
    return {
      nl: `Gebruik alleen letters en cijfers`,
      en: `Use only letters and numbers`,
    };
  }
  if (patternMismatch) {
    if (type && !customContext) {
      if (type === CONTENTFUL_INPUT_TYPES.text) {
        return {
          nl: `Gebruik alleen letters en cijfers`,
          en: `Use only letters and numbers`,
        };
      }
      if (type === CONTENTFUL_INPUT_TYPES.email) {
        return {
          nl: `Ongeldig format, gebruik bijvoorbeeld: voorbeeld@bedrijfsnaam.com`,
          en: `Invalid format, for example use: example@companyname.com`,
        };
      }
      if (type === CONTENTFUL_INPUT_TYPES.tel) {
        return {
          nl: `Gebruik alleen nummers en de volgende speciale characters zijn toegestaan - + ()`,
          en: `Only use numbers and the following special characters are allowed - + ()`,
        };
      }
    }
    if (customContext === FORM_CONTEXT_TYPES.kvkNumber) {
      return {
        nl: `Het KvK-nummer bestaat altijd uit 8 cijfers`,
        en: `The Chamber of Commerce number always consists of 8 digits`,
      };
    }
    if (customContext === FORM_CONTEXT_TYPES.currency) {
      return {
        nl: `Gebruik alleen cijfers`,
        en: `Only use numbers`,
      };
    }
    if (customContext === FORM_CONTEXT_TYPES.specialCharacters) {
      return {
        nl: `Alleen de volgende speciale tekens zijn toegestaan: @ & + - ( ) ? ! * # /`,
        en: `Only the following special characters are allowed: @ & + - ( ) ? ! * # /`,
      };
    }
    if (customContext === FORM_CONTEXT_TYPES.postalCode) {
      return {
        nl: `Moet bestaat uit 4 cijfers en 2 letters, zoals: 1234AB`,
        en: `Must consist of 4 numbers and 2 letters, such as: 1234AB`,
      };
    }
    if (customContext === FORM_CONTEXT_TYPES.numbersLettersOnly) {
      return {
        nl: `Gebruik alleen letters en cijfers`,
        en: `Use only letters and numbers`,
      };
    }
    if (customContext === FORM_CONTEXT_TYPES.accountNumber) {
      return {
        nl: `Moet bestaat uit cijfers en letters`,
        en: `Must consists of numbers and letters`,
      };
    }
    return {
      nl: `Gebruik alleen letters en cijfers, en de volgende speciale karakters: . ' ? ! , @ € # - _`,
      en: `Use only letters and numbers, and the following special characters: . ' ? ! , @ € # - _`,
    };
  }
  if (valueMissing) {
    return (
      errorText || {
        nl: `Het invullen van je ${labelForError} is verplicht`,
        en: `Filling in your ${labelForError} is mandatory`,
      }
    );
  }
  if (tooShort) {
    return (
      errorText || {
        nl: `Je ingevulde ${labelForError} is te kort, vul minimaal ${min} karakters in`,
        en: `Your ${labelForError} is too short, insert at least ${min} characters`,
      }
    );
  }
  if (tooLong) {
    return (
      errorText || {
        nl: `Je ingevulde ${labelForError} is te lang, vul maximaal ${max} karakters in`,
        en: `Your ${labelForError} is too long, insert a maximum of ${max} characters`,
      }
    );
  }
  return (
    errorText || {
      nl: `Je ingevulde ${labelForError} is niet geldig`,
      en: `Your ${labelForError} is not valid`,
    }
  );
};
